import type { Libraries } from "@react-google-maps/api";

// The session-token key is shared with the mobile app, so it lives in @inkhunt/core and is
// re-exported here to keep this the one constants module the web app imports from.
export { JWT_NAME } from "@inkhunt/core";

// Consumed by configureApi() at startup; the API URL table itself is built in core.
export const BACKEND_API_URL = import.meta.env.VITE_BACKEND_API_URL;

export const GOOGLE_URL = "https://maps.googleapis.com/maps/api";
export const GOOGLE_OAUTH_CLIENT_ID = import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID;
export const GOOGLE_MAPS_PROPS = {
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  libraries: ["places"] as Libraries,
};
